import { format, parseISO } from 'date-fns';

/** e.g. "8 Jul 2026". Returns '' for nullish input. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return format(parseISO(iso), 'd MMM yyyy');
}

/** e.g. "8 Jul". */
export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return format(parseISO(iso), 'd MMM');
}
